import { render, staticRenderFns } from "./TheAuthorisationAppBar.vue?vue&type=template&id=59c44053&scoped=true"
import script from "./TheAuthorisationAppBar.vue?vue&type=script&lang=ts"
export * from "./TheAuthorisationAppBar.vue?vue&type=script&lang=ts"
import style0 from "./TheAuthorisationAppBar.vue?vue&type=style&index=0&id=59c44053&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c44053",
  null
  
)

export default component.exports